/* =========================================================================
   Rudraksha Consultation Form
   - Mandatory-field validation with per-field errors
   - Submit stays disabled until every field is valid
   - On submit: disable + spinner, POST to Google Sheets (Apps Script web app)
   - Success / error status shown below the button
   - Supports multiple instances + Shopify theme-editor reloads
   ========================================================================= */
(function () {
  "use strict";

  var NAME_RE = /^[\p{L}][\p{L}\s.'-]{1,49}$/u; // letters + spaces/.'- , 2–50 chars
  var DIGITS_RE = /\D+/g;

  function init(root) {
    if (!root || root.dataset.rcfReady === "1") return;
    root.dataset.rcfReady = "1";

    var cfg = {
      endpoint: (root.dataset.endpoint || "").trim(),
      code: (root.dataset.code || "+91").trim(),
      successMsg:
        root.dataset.successMsg ||
        "Thank you! Our expert will call you shortly.",
      errorMsg:
        root.dataset.errorMsg || "Something went wrong. Please try again.",
      configMsg:
        root.dataset.configMsg ||
        "Form is not configured yet. Please add a Google Sheet URL.",
      submitText: root.dataset.submitText || "Submit",
      submittingText: root.dataset.submittingText || "Submitting…",
    };

    var form = root.querySelector(".rcf__form");
    var name = root.querySelector('[data-rcf="name"]');
    var dob = root.querySelector('[data-rcf="dob"]');
    var phone = root.querySelector('[data-rcf="phone"]');
    var hp = root.querySelector('[data-rcf="hp"]'); // honeypot
    var submit = root.querySelector(".rcf__submit");
    var label = root.querySelector(".rcf__submit-label");
    var status = root.querySelector(".rcf__status");
    var calBtn = root.querySelector(".rcf__cal");
    if (!form || !name || !dob || !phone || !submit) return;

    var isPhoneIndian = cfg.code.replace(DIGITS_RE, "") === "91";
    var touched = { name: false, dob: false, phone: false };
    var submitting = false;

    /* -------- Validators : return '' when valid, else message ---------- */
    function validateName() {
      var v = (name.value || "").trim().replace(/\s{2,}/g, " ");
      if (!v) return "Please enter your name.";
      if (!NAME_RE.test(v))
        return "Enter a valid name (letters only, 2–50 characters).";
      return "";
    }

    function validateDob() {
      var v = (dob.value || "").trim();
      if (!v) return "Please select your date of birth.";
      var d = new Date(v);
      if (isNaN(d.getTime())) return "Please enter a valid date.";
      var today = new Date();
      today.setHours(0, 0, 0, 0);
      if (d > today) return "Date of birth cannot be in the future.";
      var age = (today - d) / (365.25 * 24 * 3600 * 1000);
      if (age > 120) return "Please enter a valid date of birth.";
      return "";
    }

    function validatePhone() {
      var raw = (phone.value || "").replace(DIGITS_RE, "");
      if (!raw) return "Please enter your phone number.";
      if (isPhoneIndian) {
        if (!/^[6-9]\d{9}$/.test(raw))
          return "Enter a valid 10-digit mobile number.";
      } else {
        if (raw.length < 6 || raw.length > 15)
          return "Enter a valid phone number.";
      }
      if (/^(\d)\1+$/.test(raw)) return "Enter a valid phone number.";
      return "";
    }

    var validators = {
      name: validateName,
      dob: validateDob,
      phone: validatePhone,
    };
    var fields = { name: name, dob: dob, phone: phone };

    function fieldWrap(el) {
      return el.closest(".rcf__field");
    }
    function errorEl(el) {
      return fieldWrap(el).querySelector(".rcf__error");
    }

    function paintField(key) {
      var el = fields[key];
      var msg = validators[key]();
      var wrap = fieldWrap(el);
      if (touched[key] && msg) {
        wrap.classList.add("is-error");
        el.setAttribute("aria-invalid", "true");
        errorEl(el).textContent = msg;
      } else {
        wrap.classList.remove("is-error");
        el.setAttribute("aria-invalid", "false");
      }
      return !msg;
    }

    function isFormValid() {
      return !validateName() && !validateDob() && !validatePhone();
    }

    function refreshSubmit() {
      submit.disabled = submitting || !isFormValid();
    }

    /* -------- Wire up field events ------------------------------------- */
    Object.keys(fields).forEach(function (key) {
      var el = fields[key];
      el.addEventListener("input", function () {
        // clear any global status once the user edits again
        hideStatus();
        if (touched[key]) paintField(key);
        refreshSubmit();
      });
      el.addEventListener("blur", function () {
        touched[key] = true;
        paintField(key);
        refreshSubmit();
      });
    });

    /* -------- Phone: keep digits only, cap length ---------------------- */
    phone.addEventListener("input", function () {
      var cleaned = phone.value.replace(DIGITS_RE, "");
      if (isPhoneIndian) cleaned = cleaned.slice(0, 10);
      else cleaned = cleaned.slice(0, 15);
      if (cleaned !== phone.value) phone.value = cleaned;
    });

    /* -------- Date field: text ↔ date swap so the placeholder shows ---- */
    function openDatePicker() {
      if (dob.type !== "date") dob.type = "date";
      if (typeof dob.showPicker === "function") {
        try {
          dob.showPicker();
        } catch (e) {
          dob.focus();
        }
      } else {
        dob.focus();
      }
    }
    dob.addEventListener("focus", function () {
      if (dob.type !== "date") dob.type = "date";
    });
    dob.addEventListener("blur", function () {
      if (!dob.value) dob.type = "text";
    });
    if (calBtn) {
      calBtn.addEventListener("click", function (e) {
        e.preventDefault();
        openDatePicker();
      });
    }

    /* -------- Status helpers ------------------------------------------- */
    function showStatus(kind, message) {
      if (!status) return;
      status.textContent = message;
      status.classList.remove("is-success", "is-error");
      status.classList.add(
        "is-visible",
        kind === "success" ? "is-success" : "is-error",
      );
    }
    function hideStatus() {
      if (status)
        status.classList.remove("is-visible", "is-success", "is-error");
    }

    function setSubmitting(on) {
      submitting = on;
      root.classList.toggle("is-submitting", on);
      if (label) label.textContent = on ? cfg.submittingText : cfg.submitText;
      refreshSubmit();
    }

    /* -------- Submit --------------------------------------------------- */
    form.addEventListener("submit", function (e) {
      e.preventDefault();
      if (submitting) return;

      // Silent spam trap — bail out quietly if the honeypot is filled.
      if (hp && hp.value) {
        form.reset();
        return;
      }

      // Final validation pass.
      Object.keys(fields).forEach(function (k) {
        touched[k] = true;
        paintField(k);
      });
      if (!isFormValid()) {
        refreshSubmit();
        var firstBad = Object.keys(fields).filter(function (k) {
          return validators[k]();
        })[0];
        if (firstBad) fields[firstBad].focus();
        return;
      }

      if (!cfg.endpoint) {
        showStatus("error", cfg.configMsg);
        return;
      }

      var payload = new URLSearchParams();
      payload.append("name", name.value.trim().replace(/\s{2,}/g, " "));
      payload.append("date_of_birth", dob.value.trim());
      payload.append(
        "phone",
        cfg.code + " " + phone.value.replace(DIGITS_RE, ""),
      );
      payload.append("phone_code", cfg.code);
      payload.append("phone_number", phone.value.replace(DIGITS_RE, ""));
      payload.append("page_url", window.location.href);
      payload.append("submitted_at", new Date().toISOString());

      setSubmitting(true);
      hideStatus();

      /* Google Apps Script web apps don't return CORS headers we can read,
         so we POST as a "simple" request in no-cors mode. The row is written
         reliably; the promise resolves on success and rejects only on a real
         network failure. */
      fetch(cfg.endpoint, {
        method: "POST",
        mode: "no-cors",
        headers: {
          "Content-Type": "application/x-www-form-urlencoded;charset=UTF-8",
        },
        body: payload.toString(),
      })
        .then(function () {
          setSubmitting(false);
          submit.disabled = true; // stays disabled: form is now empty again
          form.reset();
          dob.type = "text";
          Object.keys(touched).forEach(function (k) {
            touched[k] = false;
          });
          Object.keys(fields).forEach(function (k) {
            fieldWrap(fields[k]).classList.remove("is-error");
            fields[k].setAttribute("aria-invalid", "false");
          });
          showStatus("success", cfg.successMsg);
        })
        .catch(function () {
          setSubmitting(false);
          refreshSubmit();
          showStatus("error", cfg.errorMsg);
        });
    });

    // Initial state.
    refreshSubmit();
  }

  function initAll(scope) {
    (scope || document).querySelectorAll(".rcf").forEach(init);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", function () {
      initAll();
    });
  } else {
    initAll();
  }

  // Shopify theme editor: re-init when the section is (re)loaded.
  document.addEventListener("shopify:section:load", function (e) {
    initAll(e.target);
  });
})();

/* ===== Popup controller — opens any [data-rcf-modal] whose id matches a #hash ===== */
(function () {
  "use strict";
  if (window.__rcfPopupReady) return;
  window.__rcfPopupReady = true;

  var OPEN = "is-open",
    LOCK = "rcf-no-scroll";
  var current = null,
    lastFocused = null;

  function modalById(id) {
    if (!id) return null;
    var el = document.getElementById(id);
    return el && el.hasAttribute("data-rcf-modal") ? el : null;
  }
  function focusables(c) {
    return c.querySelectorAll(
      'a[href],button:not([disabled]),input:not([disabled]):not([type="hidden"]),select,textarea,[tabindex]:not([tabindex="-1"])',
    );
  }
  function open(modal, trigger) {
    if (!modal || modal === current) return;
    if (current) close(current);
    lastFocused = trigger || document.activeElement;
    modal.classList.add(OPEN);
    modal.setAttribute("aria-hidden", "false");
    document.documentElement.classList.add(LOCK);
    document.body.classList.add(LOCK);
    current = modal;
    var first =
      modal.querySelector(
        'input:not([type="hidden"]):not(.rcf__hp),textarea,select',
      ) || modal.querySelector(".rcf__close");
    setTimeout(function () {
      try {
        first && first.focus();
      } catch (e) {}
    }, 40);
  }
  function close(modal) {
    modal = modal || current;
    if (!modal) return;
    modal.classList.remove(OPEN);
    modal.setAttribute("aria-hidden", "true");
    if (current === modal) current = null;
    if (!document.querySelector("[data-rcf-modal]." + OPEN)) {
      document.documentElement.classList.remove(LOCK);
      document.body.classList.remove(LOCK);
    }
    if (lastFocused && lastFocused.focus) {
      try {
        lastFocused.focus();
      } catch (e) {}
    }
    lastFocused = null;
  }

  document.addEventListener("click", function (e) {
    var t = e.target;
    if (!t || !t.closest) return;
    var a = t.closest("a[href]");
    if (a) {
      var href = a.getAttribute("href") || "";
      var hash = a.hash || (href.charAt(0) === "#" ? href : "");
      if (hash.length > 1) {
        var m = modalById(hash.slice(1));
        if (m) {
          e.preventDefault();
          open(m, a);
          return;
        }
      }
    }
    var dismiss = t.closest("[data-rcf-dismiss]");
    if (dismiss) {
      var host = dismiss.closest("[data-rcf-modal]");
      if (host) {
        e.preventDefault();
        close(host);
      }
    }
  });

  document.addEventListener("keydown", function (e) {
    if (!current) return;
    if (e.key === "Escape") {
      close(current);
      return;
    }
    if (e.key === "Tab") {
      var f = focusables(current);
      if (!f.length) return;
      var first = f[0],
        last = f[f.length - 1];
      if (e.shiftKey && document.activeElement === first) {
        e.preventDefault();
        last.focus();
      } else if (!e.shiftKey && document.activeElement === last) {
        e.preventDefault();
        first.focus();
      }
    }
  });

  function fromHash() {
    if (location.hash.length > 1) {
      var m = modalById(location.hash.slice(1));
      if (m) open(m, null);
    }
  }
  if (document.readyState === "loading")
    document.addEventListener("DOMContentLoaded", fromHash);
  else fromHash();

  document.addEventListener("shopify:section:select", function (e) {
    var m =
      e.target.querySelector && e.target.querySelector("[data-rcf-modal]");
    if (m) open(m, null);
  });
  document.addEventListener("shopify:section:deselect", function (e) {
    var m =
      e.target.querySelector && e.target.querySelector("[data-rcf-modal]");
    if (m) close(m);
  });
})();
